/* CARAVIUM COPILOT LOCAL SEARCH V1 - servicios cercanos sin consumir búsqueda web de IA */
(() => {
  const SUPABASE_URL='https://ouhtkmpgsmauyebwpqsj.supabase.co';
  const SUPABASE_KEY='sb_publishable_CBwe_LRkZmEii18EiiUtuA_uxonULzb';

  function intentFor(text){
    const m=String(text||'').toLowerCase();
    const mexican=/mexican[oa]?/.test(m);
    if(/restaurante/.test(m)) return {label:mexican?'restaurantes mexicanos':'restaurantes', clauses:[mexican?'["amenity"="restaurant"]["cuisine"~"mexican",i]':'["amenity"="restaurant"]']};
    if(/lavander/.test(m)) return {label:'lavanderías',clauses:['["shop"="laundry"]','["shop"="dry_cleaning"]']};
    if(/farmacia/.test(m)) return {label:'farmacias',clauses:['["amenity"="pharmacy"]']};
    if(/hospital|ambulator|centro de salud/.test(m)) return {label:'centros sanitarios',clauses:['["amenity"="hospital"]','["amenity"="clinic"]','["healthcare"="centre"]']};
    if(/supermerc/.test(m)) return {label:'supermercados',clauses:['["shop"="supermarket"]']};
    if(/gasolin/.test(m)) return {label:'gasolineras',clauses:['["amenity"="fuel"]']};
    if(/cafeter|café|cafe/.test(m)) return {label:'cafeterías',clauses:['["amenity"="cafe"]']};
    if(/\bbar\b/.test(m)) return {label:'bares',clauses:['["amenity"="bar"]','["amenity"="pub"]']};
    if(/taller|mecánic|mecanic/.test(m)) return {label:'talleres',clauses:['["shop"="car_repair"]']};
    if(/panader/.test(m)) return {label:'panaderías',clauses:['["shop"="bakery"]']};
    if(/carnicer/.test(m)) return {label:'carnicerías',clauses:['["shop"="butcher"]']};
    if(/ferreter/.test(m)) return {label:'ferreterías',clauses:['["shop"="hardware"]']};
    if(/veterin/.test(m)) return {label:'veterinarios',clauses:['["amenity"="veterinary"]']};
    if(/centro comercial/.test(m)) return {label:'centros comerciales',clauses:['["shop"="mall"]']};
    return null;
  }

  function distanceKm(a,b,c,d){
    const R=6371, rad=x=>x*Math.PI/180;
    const dLat=rad(c-a), dLng=rad(d-b);
    const q=Math.sin(dLat/2)**2+Math.cos(rad(a))*Math.cos(rad(c))*Math.sin(dLng/2)**2;
    return 2*R*Math.asin(Math.sqrt(q));
  }

  async function getSpot(){
    const id=new URLSearchParams(location.search).get('id')||window.__CARAVIUM_PRETTY_SPOT_ID||'';
    if(!id) throw new Error('Sin punto CARAVIUM');
    const fields='id,nombre,municipio,provincia,latitud,longitud';
    const r=await fetch(`${SUPABASE_URL}/rest/v1/spots?id=eq.${encodeURIComponent(id)}&select=${fields}&limit=1`,{headers:{apikey:SUPABASE_KEY,Authorization:`Bearer ${SUPABASE_KEY}`}});
    if(!r.ok) throw new Error('No se pudo localizar el punto');
    const rows=await r.json();
    const s=rows[0];
    if(!s) throw new Error('Punto no encontrado');
    return s;
  }

  async function overpass(intent,lat,lng){
    const radius=20000;
    const body=intent.clauses.map(c=>`nwr(around:${radius},${lat},${lng})${c};`).join('\n');
    const query=`[out:json][timeout:12];(${body});out center tags;`;
    const endpoints=['https://overpass-api.de/api/interpreter','https://overpass.kumi.systems/api/interpreter'];
    let data=null;
    for(const url of endpoints){
      try{
        const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},body:'data='+encodeURIComponent(query)});
        if(r.ok){data=await r.json();break;}
      }catch(_){ }
    }
    if(!data?.elements) throw new Error('Servicio de lugares no disponible');
    const rows=data.elements.map(e=>{
      const lat2=Number(e.lat??e.center?.lat), lng2=Number(e.lon??e.center?.lon), t=e.tags||{};
      if(!Number.isFinite(lat2)||!Number.isFinite(lng2)) return null;
      const name=String(t.name||t.brand||'').trim();
      if(!name) return null;
      const addr=[t['addr:street'],t['addr:housenumber'],t['addr:city']||t['addr:town']||t['addr:village']].filter(Boolean).join(' ');
      return {name,lat:lat2,lng:lng2,addr,d:distanceKm(lat,lng,lat2,lng2)};
    }).filter(Boolean).sort((a,b)=>a.d-b.d);
    const out=[], seen=new Set();
    for(const x of rows){
      const k=x.name.toLowerCase();
      if(seen.has(k)) continue;
      seen.add(k); out.push(x);
      if(out.length===3) break;
    }
    return out;
  }

  function openAnswer(){
    const box=document.querySelector('.cv-copilot-answer');
    const body=document.querySelector('.cv-copilot-answer__body');
    const usage=document.querySelector('.cv-copilot-answer__usage');
    if(!box||!body) return null;
    box.classList.add('is-open');
    if(usage) usage.textContent='';
    return {box,body,usage};
  }

  function loading(ui){
    ui.body.innerHTML='<div class="cv-copilot-loading"><span class="cv-copilot-dot"></span>CARAVIUM está buscando opciones cercanas…</div>';
  }

  function render(ui,intent,items){
    ui.body.innerHTML='';
    const intro=document.createElement('div');
    intro.style.marginBottom='8px';
    intro.textContent=items.length?'Estas son las opciones más cercanas que he encontrado:':`No he encontrado ${intent.label} con nombre confirmado a menos de 20 km de este punto.`;
    ui.body.appendChild(intro);
    items.forEach((x,i)=>{
      const row=document.createElement('div');
      row.style.margin='10px 0 12px';
      const title=document.createElement('div');
      title.style.fontWeight='800';
      const dist=x.d<1?`${Math.round(x.d*1000)} m`:`${x.d.toFixed(1).replace('.',',')} km`;
      title.textContent=`${i+1}. ${x.name} · aprox. ${dist}${x.addr?` · ${x.addr}`:''}`;
      const link=document.createElement('a');
      link.className='cv-copilot-map-link';
      link.href=`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(x.lat+','+x.lng)}`;
      link.target='_blank';
      link.rel='noopener noreferrer';
      link.textContent='📍 Cómo llegar';
      row.appendChild(title);
      row.appendChild(link);
      ui.body.appendChild(row);
    });
    if(ui.usage) ui.usage.textContent='Búsqueda cercana CARAVIUM · resultados de OpenStreetMap';
  }

  document.addEventListener('submit',async e=>{
    const form=e.target;
    if(!(form instanceof HTMLFormElement)||form.id!=='cv-copilot-question-form') return;
    if(form.dataset.cvLocalBypass==='1'){
      delete form.dataset.cvLocalBypass;
      return;
    }
    const input=form.querySelector('#cv-copilot-question-input');
    const question=String(input?.value||'').trim();
    const intent=intentFor(question);
    if(!intent) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    const btn=form.querySelector('.cv-copilot-question__submit');
    if(btn){btn.disabled=true;btn.textContent='Buscando…';}
    const ui=openAnswer();
    if(!ui){form.dataset.cvLocalBypass='1';form.requestSubmit();return;}
    loading(ui);
    try{
      const spot=await getSpot();
      const lat=Number(spot.latitud),lng=Number(spot.longitud);
      if(!Number.isFinite(lat)||!Number.isFinite(lng)) throw new Error('Sin coordenadas');
      const items=await overpass(intent,lat,lng);
      render(ui,intent,items);
    }catch(_){
      form.dataset.cvLocalBypass='1';
      form.requestSubmit();
    }finally{
      if(btn){btn.disabled=false;btn.textContent='Preguntar';}
    }
  },true);
})();